<template>
  <div class="footer">
    <!-- footer -->
    <div class="footer">
      <img
        src="../../assets/image/footer/footer_logo.png"
        alt=""
        class="footer_logo"
      />
      <div class="footer_nav_box">
        <span @click="goHome">关于我们</span>
        <span @click="goAbout">公司简介</span>
        <span @click="goHome">服务介绍</span>
        <span @click="goHome">联系我们</span>
      </div>
      <div class="contach_box">
        <div class="phone_box">
          <span>座机 : </span>
          <b>010-88801917</b>
          <span style="margin-left:10px;">手机 : </span>
          <b>周先生 13146926876</b>
        </div>
        <div class="adress">地址：北京市石景山区实兴大街30号院7号楼8层88号</div>
        <div class="net">网址: www.zhuowendata.com</div>
      </div>
      <div class="cut_line"></div>
      <div class="copy_right">
        <a href="http://beian.miit.gov.cn">京ICP备2021000793号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // 跳转首页
    goHome() {
      this.$router.push({ path: "/index" });
    },
    // 跳转关于我们
    goAbout() {
      this.$router.push({ path: "/about" });
    },
  },
};
</script>
<style scoped lang='less'>
.footer {
  width: 100%;
  height: 291px;
  background: #494e59;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  .footer_logo {
    margin-top: 30px;
    width: 170px;
    height: 54px;
  }
  .footer_nav_box {
    margin-top: 30px;
    display: flex;
    align-items: center;
    span {
      margin-right: 80px;
      // a {
      font-size: 16px;
      line-height: 22px;
      color: rgba(255, 255, 255, 0.8);
      // }
    }
  }
  .contach_box {
    margin-top: 36px;
    display: flex;
    align-items: center;
    .phone_box {
      display: flex;
      align-items: baseline;
      span {
        font-size: 16px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.8);
      }
      b {
        margin-left: 5px;
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .adress,
    .net {
      margin-left: 103px;
      font-size: 16px;
      line-height: 22px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
  .cut_line {
    margin-top: 41px;
    width: 1200px;
    height: 1px;
    background: linear-gradient(
      90deg,
      rgba(76, 73, 89, 0),
      #ffffff 52%,
      rgba(76, 73, 89, 0)
    );
  }
  .copy_right {
    a {
      margin: 16px 0;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer/footer.vue